import type { OpenClawApp } from "./app.ts";
import {
  parseSessionKeyPath,
  sessionKeyFromPath,
  type SessionKeyPath,
} from "./chat/session-key-path.ts";
import { loadChatModelCatalog } from "./controllers/chat-models.ts";
import type { LlmStatsTabId } from "./controllers/llm-stats-scope.ts";
import type { LlmStatsState } from "./controllers/llm-stats.ts";
import { loadSessionTrace } from "./controllers/llm-stats.ts";

export function applyLlmStatsTab(app: OpenClawApp, tab: LlmStatsTabId): void {
  app.applySettings({
    ...app.settings,
    llmStatsTab: tab,
  });
  if (tab === "trace" && app.usageSelectedSessions.length === 1) {
    void loadSessionTrace(app as unknown as LlmStatsState, app.usageSelectedSessions[0]);
  }
  if (tab === "connect") {
    void loadChatModelCatalog(app);
  }
}

export function applyLlmStatsViewAll(app: OpenClawApp, viewAll: boolean): void {
  app.applySettings({
    ...app.settings,
    llmStatsViewAll: viewAll,
    ...(viewAll ? { llmStatsScopeLinked: false } : {}),
  });
}

export function applyLlmStatsScopeLinked(app: OpenClawApp, linked: boolean): void {
  app.applySettings({
    ...app.settings,
    llmStatsScopeLinked: linked,
    ...(linked ? { llmStatsScopePath: parseSessionKeyPath(app.settings.sessionKey) } : {}),
  });
}

export function applyLlmStatsScopePath(app: OpenClawApp, path: SessionKeyPath): void {
  app.applySettings({
    ...app.settings,
    llmStatsScopeLinked: false,
    llmStatsScopePath: path,
  });
  const key = sessionKeyFromPath(path);
  if (key) {
    app.usageSelectedSessions = [key];
  }
}
